import React, {Suspense, useEffect} from 'react'
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom'
import {Provider} from "react-redux"
import {store} from "./store"
import {ErrorBoundary} from './ErrorBoundary'
import {Skeleton} from './components/skeleton/Skeleton'
import * as Sentry from '@sentry/browser'
import {getUserInfo, getSystemInfo} from "./utils/bridge"
import {isAndroid, isIOS} from './utils/config'
import Daily from './pages/Daily/Daily'
import InfoList from "./pages/OperationList"
import DailyPage from "./pages/DailyPage"
import {Test} from "./pages/Test"

export const Routers: React.FC = () => {
  const inAB = window['mytantanH5-gloable-inAB']
  useEffect(() => {
    (async () => {
      const {userId = 22957} = await getUserInfo()
      const {versionCode = '4.3.7'} = await getSystemInfo()
      Sentry.configureScope((scope: any) => {
        scope.setUser({id: userId})
        scope.setTag('browser', window.navigator.userAgent)
        scope.setTag('os', isAndroid ? 'android' : (isIOS ? 'ios' : 'undefined'))
        scope.setExtra('version', versionCode)
      })
    })()
  }, [])
  return (
    <Provider store={store}>
      <ErrorBoundary>
        <Router>
          <Suspense fallback={<Skeleton/>}>
            <Switch>
              <Route exact path="/" component={inAB ? InfoList : Daily} />
              <Route exact path="/daily/page" component={DailyPage} />
              <Route exact path="/test" component={Test} />
            </Switch>
          </Suspense>
        </Router>
      </ErrorBoundary>
    </Provider>
  )
}
